const VIEW_STAFF_PERMISSION = 1;
const ADD_STAFF_PERMISSION = 2;
const EDIT_STAFF_PERMISSION = 3;
const DELETE_STAFF_PERMISSION = 4;

const VIEW_BASIC_COMPLAINT_TYPE_PERMISSION = 6;
const VIEW_COMPLETE_COMPLAINT_TYPE_PERMISSION = 7;
const MANAGE_COMPLAINT_TYPE_PERMISSION = 8;

const VIEW_BASIC_DOCUMENT_PERMISSION = 9;
const VIEW_COMPLETE_DOCUMENT_PERMISSION = 10;
const MANAGE_DOCUMENT_PERMISSION = 11;

const VIEW_CLINIC_PERMISSION = 12;
const ADD_CLINIC_PERMISSION = 13;
const EDIT_CLINIC_PERMISSION = 14;
const DELETE_CLINIC_PERMISSION = 15;

const VIEW_PATIENT_PERMISSION = 16;
const ADD_PATIENT_PERMISSION = 17;
const EDIT_PATIENT_PERMISSION = 18;
const DELETE_PATIENT_PERMISSION = 19;

const VIEW_BASIC_COMPLAINT_CASE_PERMISSION = 20;
const VIEW_COMPLETE_COMPLAINT_CASE_PERMISSION = 21;
const ADD_COMPLAINT_CASE_PERMISSION = 22;
const EDIT_COMPLAINT_CASE_NOTES_PERMISSION = 23;
const FILL_COMPLAINT_CASE_FORM_PERMISSION = 24;
const FINISH_COMPLAINT_CASE_PERMISSION = 25;
const DELETE_COMPLAINT_CASE_PERMISSION = 26;

export {
    VIEW_STAFF_PERMISSION,
    ADD_STAFF_PERMISSION,
    EDIT_STAFF_PERMISSION,
    DELETE_STAFF_PERMISSION,
    VIEW_BASIC_COMPLAINT_TYPE_PERMISSION,
    VIEW_COMPLETE_COMPLAINT_TYPE_PERMISSION,
    MANAGE_COMPLAINT_TYPE_PERMISSION,
    VIEW_BASIC_DOCUMENT_PERMISSION,
    VIEW_COMPLETE_DOCUMENT_PERMISSION,
    MANAGE_DOCUMENT_PERMISSION,
    VIEW_CLINIC_PERMISSION,
    ADD_CLINIC_PERMISSION,
    EDIT_CLINIC_PERMISSION,
    DELETE_CLINIC_PERMISSION,
    VIEW_PATIENT_PERMISSION,
    ADD_PATIENT_PERMISSION,
    EDIT_PATIENT_PERMISSION,
    DELETE_PATIENT_PERMISSION,
    VIEW_BASIC_COMPLAINT_CASE_PERMISSION,
    VIEW_COMPLETE_COMPLAINT_CASE_PERMISSION,
    ADD_COMPLAINT_CASE_PERMISSION,
    EDIT_COMPLAINT_CASE_NOTES_PERMISSION,
    FILL_COMPLAINT_CASE_FORM_PERMISSION,
    FINISH_COMPLAINT_CASE_PERMISSION,
    DELETE_COMPLAINT_CASE_PERMISSION
};